import { DownsellStep } from "@redotech/redo-model/advanced-flow/steps";
import { FrontendStepType, PartialWithRequiredType } from ".";
import { UpsellInspector } from "./inspectors/upsell-inspector";

export const downsellStepType: FrontendStepType<
  PartialWithRequiredType<DownsellStep>
> = {
  type: "standard",
  valid: (step) => true,
  inspectorFactory: (outerProps) => ({
    header: { title: outerProps.step.name ?? "Downsell" },
    sections: [
      {
        fields: [
          { path: "name", label: "Downsell name", widget: "text" },
          {
            path: "downsellId",
            label: "",
            widget: "custom",
            Element: (props) => {
              return (
                <UpsellInspector
                  doSave={outerProps.save}
                  upsellId={props.value.downsellId ?? ""}
                />
              );
            },
          },
        ],
      },
    ],
  }),
};
